import PropTypes from "prop-types";
//import "./AccountGrid.css";

export default function AccountGrid({
  title = "Select an Account",
  accounts = [],
  onSelect,
}) {
  return (
    <div className="accounts-wrapper">
      <h2 className="accounts-title">{title}</h2>

      <div className="accounts-grid">
        {accounts.map((acc) => (
          <button
            key={acc.id}
            className="account-card"
            onClick={() => onSelect?.(acc)}
            aria-label={`Select ${acc.name}`}
          >
            <img
              src={acc.avatar || "../../avatar-placeholder.svg"} 
              alt={acc.name}
			  className="accounts-avayar"
              loading="lazy"
            />
            <h3>{acc.name}</h3>
            {acc.meta && <p>{acc.meta}</p>}
          </button>
        ))}

      </div>
    </div>
  );
}

AccountGrid.propTypes = {
  title: PropTypes.string,
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      avatar: PropTypes.string,
      meta: PropTypes.string,
    })
  ),
  onSelect: PropTypes.func,
};
